import { booleanIntersects } from '@turf/boolean-intersects';
import { booleanPointInPolygon } from '@turf/boolean-point-in-polygon';
import type { Feature, Polygon } from 'geojson';

import { GeoJSONGeometry } from '@atom/types/geojson';

export type ItemWithLocation = {
  id: string;
  location: GeoJSONGeometry;
};

const isInsideCircle = (
  item: ItemWithLocation,
  circle: Feature<Polygon>,
): boolean => {
  const { location } = item;

  if (location.type === 'Point') {
    return booleanPointInPolygon(location.coordinates, circle);
  }

  const feature: Feature = {
    type: 'Feature',
    properties: {},
    geometry: location as GeoJSON.Geometry,
  };
  return booleanIntersects(feature, circle);
};

const grabFilter = (
  items: ItemWithLocation[],
  circle: Feature<Polygon>,
): string[] =>
  items.filter(item => isInsideCircle(item, circle)).map(({ id }) => id);

export default grabFilter;
